import * as moment from "moment";
import { IPageModel, PageModel } from "./page.model";
import {IPermissionModel, PermissionModel} from "./permission.model";

export interface IOptionModel {
  id?: number;
  name: string;
  application_id: number;
  page_id: number;
  page?: IPageModel;
  is_enabled: boolean;
  is_visible: boolean;
  link: string;
  icon: string;
  title: string;
  name_translate: string;
  description_translate: string;
  order_visible: number;
  role_added?: boolean;
  permissions?: IPermissionModel[];
  parentOptionName: string;
  created?: moment.Moment;
  modified?: moment.Moment;
}

export interface IResultOptionModel {
  count: number;
  next: string;
  previous: string;
  results: IOptionModel[];
}

export class OptionModel {
  id?: number;
  name: string;
  applicationId: number;
  pageId: number;
  page?: PageModel;
  isEnabled: boolean;
  isVisible: boolean;
  link: string;
  icon: string;
  title: string;
  roleAdded: boolean;
  nameTranslate: string;
  descriptionTranslate: string;
  orderVisible: number;
  parentOptionName: string;
  permissions?: PermissionModel[];
  created?: moment.Moment;
  modified?: moment.Moment;

  constructor() {
    this.isEnabled = true;
    this.isVisible = true;
    this.orderVisible = 1;
    this.roleAdded = false;
  }

  static fromObject(parent:string, option: IOptionModel): OptionModel {
    let obj = new OptionModel();
    obj.id = option.id;
    obj.name = option.name;
    obj.applicationId = option.application_id;
    obj.isEnabled = option.is_enabled;
    obj.isVisible = option.is_visible;
    obj.pageId = option.page_id;
    obj.page = (option.page) ? PageModel.fromObject(option.page) : undefined;
    obj.title = option.title;
    obj.link = option.link;
    obj.icon = option.icon;
    obj.nameTranslate = option.name_translate;
    obj.descriptionTranslate = option.description_translate
    obj.orderVisible = option.order_visible;
    obj.parentOptionName = parent;
    obj.created = moment(option.created);
    obj.modified = moment(option.modified);
    if (option.role_added != undefined)
      obj.roleAdded = option.role_added
    obj.permissions = (option.permissions && option.permissions.length > 0) ? PermissionModel.fromObjectArray(option.permissions) : [];
    return obj;
  }

  static fromObjectArray(parent:string,options: IOptionModel[]): OptionModel[] {
    return options.map((option: IOptionModel) => OptionModel.fromObject(parent,option));
  }
}

export class ResultOptionModel {
  count: number = 0;
  next: string;
  previous: string;
  results: OptionModel[] = [];

  constructor() {
    this.count = 0;
  }

  static fromObject(result: IResultOptionModel): ResultOptionModel {
    let obj = new ResultOptionModel();
    obj.count = result.count | 0;
    obj.next = result.next;
    obj.previous = result.previous;
    obj.results = (result.results && result.results.length > 0) ? OptionModel.fromObjectArray("",result.results) : [];
    return obj;
  }
}
